import { render, staticRenderFns } from "./AssetBySupplier.vue?vue&type=template&id=6defdc80"
import script from "./AssetBySupplier.vue?vue&type=script&lang=js"
export * from "./AssetBySupplier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports